import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import IconButton from '@material-ui/core/IconButton';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import Pagination from '@mui/material/Pagination';
import Stack from '@mui/material/Stack';
import axios from 'axios';
import EnhancedTableHead, {
  Transition,
} from '../../components/Common/EnhancedTableHead';

import { Button, InputLabel, Select, MenuItem } from '@material-ui/core';
import { Delete, Edit, Visibility } from '@material-ui/icons';
import AddDialectTypeDialog from './AddDialectTypeDialog';
import DeleteDailog from '../../components/Common/DeleteDailog';
import toastr from 'toastr';
import 'toastr/build/toastr.min.css';
import { baseUrl, languageId } from '../../helpers/EncryptionHelper';
import LoadIndicator from '../../components/Common/LoadIndicator';
import SearchBar from '../../components/Common/Search';

const headCells = [
  {
    id: 'dialect_type_name',
    numeric: false,
    disablePadding: false,
    label: 'Dialect Type Name',
  },
  {
    id: 'actions',
    numeric: false,
    disablePadding: false,
    label: 'Actions',
    align: 'center',
  },
];

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  paper: {
    width: '100%',
    marginBottom: theme.spacing(2),
    padding: theme.spacing(3),
  },
  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },
}));

export default function CustomTableDialectType() {
  const classes = useStyles();
  const [order, setOrder] = useState('asc');
  const [orderBy, setOrderBy] = useState('dialect_type_name');
  const [selected, setSelected] = useState([]);
  const [dense, setDense] = useState(false);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const [openDailog, setOpenDailog] = useState(false);
  const [openDeleteDailog, setOpenDeleteDailog] = useState(false);
  const [editDialectType, setEditDialectType] = useState(false);
  const [selectedDialectType, setselectedDialectType] = useState(false);

  const [rows, setRows] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [limit, setLimit] = useState(10);
  const [showLoader, setShowLoader] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [searchType, setSearchType] = useState('starts');
  const [currentPage, setCurrentPage] = useState(1);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleClose = () => {
    setEditDialectType(false);
    setselectedDialectType();
    setOpenDailog(false);
  };

  function handleCloseDeleteDailog() {
    setselectedDialectType();
    setOpenDeleteDailog(false);
  }

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = rows.map((n) => n);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setLimit(parseInt(event.target.value, 10));
    setCurrentPage(1);
  };

  const handleChangeDense = (event) => {
    setDense(event.target.checked);
  };

  const handleDelete = async (id) => {
    axios
      .delete(baseUrl + `/dialect-type/remove/${id}`)
      .then((res) => {
        if (res && res.data.status === 200) {
          handleCloseDeleteDailog();
          toastr.success('Dialect Type Deleted Successfully', 'Success');
          fetchData((currentPage - 1) * limit, limit, searchTerm, searchType);
        }
      })
      .catch((err) => {
        toastr.error(`Dialect Type removal Failed`, 'Error!');
      });
  };

  const handleCloseAndRefresh = () => {
    setOpenDailog(false);
    setSelected([]);
    setTimeout(() => {
      fetchData((currentPage - 1) * limit, limit, searchTerm, searchType);
    }, 200);
  };

  const fetchData = async (offset, limit, search = '', type = 'starts') => {
    setShowLoader(true);
    axios
      .get(
        baseUrl +
        `/dialect-type/all?limit=${limit}&offset=${offset}&search=${search}&type=${type}&language=${languageId}`
      )
      .then((res) => {
        if (res && res.data.status === 200) {
          setRows(res.data.data.list || []);
          setTotalCount(res.data.data.totalCount || 0);
          setShowLoader(false);
        }
      })
      .catch((err) => {
        console.log('error', err);
        setShowLoader(false);
      });
  };

  useEffect(() => {
    fetchData((currentPage - 1) * limit, limit, searchTerm, searchType);
  }, [limit, currentPage, searchTerm, searchType]);

  const totalPages = Math.ceil(totalCount / limit);

  const handleChange = (event, value) => {
    setCurrentPage(value);
  };

  const handleSearch = (term) => {
    setSearchTerm(term);
    setCurrentPage(1);
  };

  const currentData = rows;

  return (
    <div className={classes.root}>
      <Button
        style={{
          backgroundColor: '#257b59',
          color: 'white',
          padding: 10,
          alignSelf: 'flex-end',
          marginBottom: 20,
        }}
        onClick={() => {
          setselectedDialectType();
          setOpenDailog(true);
        }}
      >
        Add Dialect Type
      </Button>
      <Paper className={classes.paper}>
        {showLoader ? (
          <LoadIndicator />
        ) : (
          <>
            <div style={{ display: 'flex', alignItems: 'center', marginBottom: '20px', gap: '20px' }}>
              <div>
                <InputLabel id="search-type-label">Search Type</InputLabel>
                <Select
                  labelId="search-type-label"
                  id="search-type-select"
                  value={searchType}
                  onChange={(e) => {
                    setSearchType(e.target.value);
                    setCurrentPage(1);
                  }}
                >
                  <MenuItem value={'starts'}>Starts with</MenuItem>
                  <MenuItem value={'contains'}>Contains</MenuItem>
                  <MenuItem value={'match'}>Exact Match</MenuItem>
                </Select>
              </div>
              <div style={{ flex: 1 }}>
                <SearchBar value={searchTerm} onSearch={handleSearch} />
              </div>
            </div>
            <TableContainer>
              <Table
                className={classes.table}
                aria-labelledby='tableTitle'
                size={dense ? 'small' : 'medium'}
                aria-label='enhanced table'
              >
                <EnhancedTableHead
                  classes={classes}
                  numSelected={selected.length}
                  order={order}
                  orderBy={orderBy}
                  onSelectAllClick={handleSelectAllClick}
                  onRequestSort={handleRequestSort}
                  rowCount={rows.length}
                  headCells={headCells}
                />
                <TableBody>
                  {currentData.map((row, index) => {
                    return (
                      <TableRow hover tabIndex={-1} key={index}>
                        <TableCell align='left'>
                          {row.dialectName || row.name || row.dialect_type_name}
                        </TableCell>
                        <TableCell width={'30%'} align='center'>
                          <IconButton
                            variant='contained'
                            style={{ color: '#ddd' }}
                            onClick={() => {
                              setselectedDialectType(row);
                              setOpenDailog(true);
                            }}
                          >
                            <Visibility />
                          </IconButton>
                          <IconButton
                            variant='contained'
                            style={{ color: '#ddd' }}
                            onClick={() => {
                              setEditDialectType(true);
                              setselectedDialectType(row);
                              setOpenDailog(true);
                            }}
                          >
                            <Edit />
                          </IconButton>
                          <IconButton
                            variant='contained'
                            style={{ color: '#ddd' }}
                            onClick={() => {
                              setOpenDeleteDailog(true);
                              setselectedDialectType(row);
                            }}
                          >
                            <Delete />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    );
                  })}
                  {rows.length === 0 && (
                    <TableRow style={{ height: (dense ? 33 : 53) * limit }}>
                      <TableCell colSpan={6} align="center">No data found</TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
            <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '20px' }}>
              <Stack spacing={2}>
                <Pagination
                  count={totalPages}
                  page={currentPage}
                  onChange={handleChange}
                  color="primary"
                  variant="outlined" shape="rounded"
                />
              </Stack>
            </div>
          </>
        )}
      </Paper>
      <FormControlLabel
        control={<Switch checked={dense} onChange={handleChangeDense} />}
        label='Dense padding'
      />

      {openDailog && (
        <AddDialectTypeDialog
          data={selectedDialectType}
          visible={openDailog}
          handleClose={handleClose}
          Transition={Transition}
          editDialectType={editDialectType}
        />
      )}
      {openDeleteDailog && (
        <DeleteDailog
          data={selectedDialectType}
          visible={openDeleteDailog}
          handleClose={handleCloseDeleteDailog}
          Transition={Transition}
          dialogTitle={() => (
            <div className='mt-3'>
              Do you want to delete this Dialect Type :{' '}
              <strong>{selectedDialectType?.dialectName || selectedDialectType?.name || selectedDialectType?.dialect_type_name || 'NA'}</strong>
            </div>
          )}
          handleDeleteClicked={(data) => handleDelete(data?._id || data?.id || data?.dialect_type_id)}
        />
      )}
    </div>
  );
}
